/**
 * Shipment table column configuration for Analytics
 * Defines which columns support filtering and sorting
 */

/**
 * Columns that support filtering with metadata
 */
export const SHIPMENT_FILTER_COLUMNS = new Set([
  'shipmentNumber',
  'mbl',
  'serviceType',
  'invoiceNumber',
  'serviceProvider',
  'modality',
  'billedEntity',
  'pol',
  'pod',
  'shipper',
  'shipperCountry',
  'consignee',
  'consigneeCountry',
  'goodsName',
  'vehicleId',
  'shipmentCurrentDeviationWorkflow',
  'shipmentStatus',
  'shipmentStatusReason',
  'shipmentChargesCount',
]);

/**
 * Columns that support sorting only (no filter metadata)
 */
export const SHIPMENT_SORT_ONLY_COLUMNS = new Set([
  'date',
  'leadTime',
  'invoiceAmountAfterTax',
  'totalAmount',
  'totalChargeAmountLeg1',
  'totalChargeAmountLeg2',
  'totalChargeAmountLeg3',
  'grossWeight',
  'chargeableWeight',
  'volume',
  'co2Emission',
]);

/**
 * All sortable columns (filter + sort-only)
 */
export const SHIPMENT_SORTABLE_COLUMNS = new Set([...SHIPMENT_FILTER_COLUMNS, ...SHIPMENT_SORT_ONLY_COLUMNS]);

/**
 * Maps UI column accessorKeys to API column names
 */
export const SHIPMENT_COLUMN_NAME_MAP: Record<string, string> = {
  shipmentNumber: 'SHIPMENT_NUMBER',
  mbl: 'MBL',
  serviceType: 'SERVICE_TYPE',
  invoiceNumber: 'INVOICE_NUMBER',
  serviceProvider: 'SERVICE_PROVIDER',
  modality: 'MODALITY',
  billedEntity: 'BILLED_ENTITY',
  pol: 'POL',
  pod: 'POD',
  shipper: 'SHIPPER_NAME',
  shipperCountry: 'SHIPPER_COUNTRY',
  consignee: 'CONSIGNEE_NAME',
  consigneeCountry: 'CONSIGNEE_COUNTRY',
  goodsName: 'GOOD_NAME',
  vehicleId: 'VEHICLE_ID',
  shipmentCurrentDeviationWorkflow: 'SHIPMENT_CURRENT_DEVIATION_WORKFLOW',
  shipmentStatus: 'SHIPMENT_STATUS',
  shipmentStatusReason: 'SHIPMENT_STATUS_REASON',
  shipmentChargesCount: 'CHARGE_COUNT',
};
